import { useEffect, useRef } from "react";
import styles from "./custom-input-textarea.module.scss";

const CustomInputTextArea = ({
	id,
	name,
	label,
	value,
	onChange,
	placeholder = "",
	required = false,
	disabled = false,
	error = "",
	helper = "",
	size = "md", // sm | md | lg
	col = 12, // 12 = full, 6 = half
	rows = 4,
	autoResize = false,
	maxLength,
	showCount = false,
	autoFocus = false,
	className,
	style,
}) => {
	const inputId = useRef(id || `${name || "textarea"}-${Math.random().toString(36).slice(2)}`).current;
	const taRef = useRef(null);

	useEffect(() => {
		if (!autoResize || !taRef.current) return;
		taRef.current.style.height = "auto";
		taRef.current.style.height = `${taRef.current.scrollHeight}px`;
	}, [value, autoResize]);

	const colClass = col === 6 ? styles.col6 : styles.col12;
	const describedBy = error ? `${inputId}-error` : helper ? `${inputId}-helper` : undefined;

	return (
		<div className={`${styles.field} ${colClass} ${className || ""}`} style={style}>
			{label ? (
				<label htmlFor={inputId} className={styles.label}>
					{label} {required ? <span className={styles.req}>*</span> : null}
				</label>
			) : null}

			<div className={styles.inputWrap}>
				<textarea
					ref={taRef}
					id={inputId}
					name={name}
					className={`${styles.textarea} ${styles[size]} ${error ? styles.textareaError : ""}`}
					value={value ?? ""}
					onChange={(e) => onChange?.(e.target.value)}
					placeholder={placeholder}
					required={required}
					disabled={disabled}
					rows={rows}
					maxLength={maxLength}
					autoFocus={autoFocus}
					aria-invalid={!!error || undefined}
					aria-describedby={describedBy}
				/>
				{showCount && typeof maxLength === "number" ? (
					<span className={styles.counter}>
						{value?.length || 0}/{maxLength}
					</span>
				) : null}
			</div>

			{error ? (
				<div id={`${inputId}-error`} className={styles.error}>
					{error}
				</div>
			) : helper ? (
				<div id={`${inputId}-helper`} className={styles.helper}>
					{helper}
				</div>
			) : null}
		</div>
	);
};

export default CustomInputTextArea;
